import { Resume } from '@/types/resume/v1'
import { Paragraph, SectionType, HeadingLevel, ISectionOptions } from 'docx'

const interests = ({ interests }: Resume.Schema): ISectionOptions => {
  const interestList = interests.map(i => i.name).join(', ')
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Interests',
        heading: HeadingLevel.HEADING_2,
      }),
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: interestList,
      }),
    ],
  }
}

export default interests
